// export this package's api
'use strict';

module.exports = require('./Animate');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-animate/lib/index.js
 ** module id = 440
 ** module chunks = 0
 **/